import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
import { PhoneNumberUtil } from 'google-libphonenumber';
@Component({
  selector: 'app-validate-lead-phone',
  templateUrl: './validate-lead-phone.component.html',
  styleUrls: ['./validate-lead-phone.component.scss']
})
export class ValidateLeadPhoneComponent implements OnInit {



  ngOnInit() {
  }
  public authToken = localStorage.getItem("token");
    public userInfo = JSON.parse(localStorage.getItem("userInfo"));
    types: any[] = []
    public min = new Date()
    btnStatus: boolean = false
    editLeadForm: FormGroup;
    showEmail: boolean = false
    showPhone: boolean = false
    vendorRequired: boolean = false
    isShowMoreField:boolean=false;
    num = true
    constructor(
        private serverService: ServerService,
        private clipBoardService: ClipBoardService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ValidateLeadPhoneComponent>,
        @Inject(MAT_DIALOG_DATA) private data) {
            //console.log(data)
        this.editLeadForm = this.fb.group({
            phone: [this.data.phone, Validators.required],
            // meta:[''],
        })

        this.userInfo.permissions.forEach(element => {
           
            if (element.name == "phone") {
                this.showPhone = true
            }
        });
        if (!this.showPhone) {
            this.editLeadForm.controls["phone"].setValidators([]);
            this.editLeadForm.controls["phone"].updateValueAndValidity()
        }

    }
    save() {
        this.btnStatus = true
        let body = {
        }
       
        if (this.showPhone) {
            body["phone"] = this.editLeadForm.value.phone;
        }
        this.serverService.updateLead(this.data, body, this.authToken).subscribe(
            data => {
                this.btnStatus = false
                this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                //this.dialogRef.close(data)
                this.dialogRef.close(this.editLeadForm.value.phone)
            },
            err => {
                this.btnStatus = true
                this.clipBoardService.checkServerError(err, this.authToken)
            }
        )
    }

    close() {
        this.dialogRef.close();
    }

    showMoreField(){
        this.isShowMoreField=!this.isShowMoreField;
    }
    onKeyPress(event:any) {
        const allowedCharacters = /[0-9\+]/;
        const inputChar = String.fromCharCode(event.keyCode);
      // console.log(event.target.value)
        if (!allowedCharacters.test(inputChar)) {
          event.preventDefault();
        }

        const phoneUtil = PhoneNumberUtil.getInstance();
        try {
          const parsedNumber = phoneUtil.parse(event.target.value);
          const val = phoneUtil.isValidNumber(parsedNumber)
          // console.log('hi---->'+ val)
          if(val == true){
            this.num = false;
          }
          else{
            this.num =  true;
          }
        } catch (error) {
          this.num =  true; // Invalid phone number format
        }
        // console.log(this.num)
      }
       
}
